export type FilePreviewRendererKind = 'apryse' | 'unsupported';

const APRYSE_EXTENSIONS = new Set<string>([
  // PDF family
  'pdf',
  'fdf',
  'xfdf',

  // Office — Word
  'doc',
  'docx',
  'docm',
  'dot',
  'dotx',
  'dotm',

  // Office — Excel
  'xls',
  'xlsx',
  'xlsm',
  'xlt',

  // Office — PowerPoint
  'ppt',
  'pptx',
  'pptm',
  'pot',
  'pps',

  // Images
  'jpg',
  'jpeg',
  'jfif',
  'png',
  'tif',
  'tiff',
]);

/** Extensions with an extractable text layer, so the previewer's search is meaningful. Images are excluded. */
const SEARCHABLE_EXTENSIONS = new Set<string>([
  // PDF
  'pdf',

  // Office — Word
  'doc',
  'docx',
  'docm',
  'dot',
  'dotx',
  'dotm',

  // Office — Excel
  'xls',
  'xlsx',
  'xlsm',
  'xlt',

  // Office — PowerPoint
  'ppt',
  'pptx',
  'pptm',
  'pot',
  'pps',
]);

/** Lowercase extension without the leading dot, or `''` if the name has no extension. */
export function getFileExtension(fileName: string | null | undefined): string {
  if (!fileName) return '';
  const dot = fileName.lastIndexOf('.');
  if (dot < 0 || dot === fileName.length - 1) return '';
  return fileName.slice(dot + 1).toLowerCase();
}

export function getRendererForExtension(fileName: string | null | undefined): FilePreviewRendererKind {
  return APRYSE_EXTENSIONS.has(getFileExtension(fileName)) ? 'apryse' : 'unsupported';
}

export function isSupportedExtension(fileName: string | null | undefined): boolean {
  return getRendererForExtension(fileName) !== 'unsupported';
}

/** Whether the file type carries a text layer the previewer can search (PDF/Word/Excel/PowerPoint, not images). */
export function supportsTextSearch(fileName: string | null | undefined): boolean {
  return SEARCHABLE_EXTENSIONS.has(getFileExtension(fileName));
}
